/**
 * Thinking Engine — plan confidence.
 *
 * Deterministic: how sure the reasoning is, given research quality, a resolved
 * genome, brief completeness, whether memory flagged a duplicate, and any
 * self-review issues.
 */

const round2 = (n) => Math.round(n * 100) / 100;
const clamp01 = (n) => Math.max(0, Math.min(1, n));

/**
 * @param {Object} ctx        reasoning context (brief, research, genome, constraints).
 * @param {Object} selfReview { consistent, notes }.
 * @returns {number} 0–1.
 */
export const computeConfidence = (ctx, selfReview) => {
  const researchConfidence = typeof ctx.research.confidence === 'number' ? ctx.research.confidence : 0.4;
  let c = 0.45 + 0.3 * researchConfidence + (ctx.genome ? 0.1 : 0);
  if (ctx.brief.industry) c += 0.05;
  if (ctx.brief.purpose) c += 0.05;
  if (ctx.constraints.diversityConstraints && ctx.constraints.diversityConstraints.duplicate) c -= 0.1;
  c -= 0.1 * selfReview.notes.length;
  return round2(clamp01(c));
};
